import * as marietta from '../../..';

/**
 * ポイントスナップを扱うクラス
 */
export default class PointSnap {
    type: string;

    x: number;

    y: number;

    radius: number;

    priority: number;

    related: any;

    itemType: string;

    /**
    * コンストラクタ
    */
    constructor(x: number, y: number, radius: number, priority: number, related: any, itemType: string = 'point') {
      this.type = 'point';
      this.x = x;
      this.y = y;
      this.radius = radius;
      this.priority = priority;
      this.related = related;
      this.itemType = itemType;
    }

    /**
     * 最も近いポイントを取得します
     * @param x
     * @param y
     * @returns
     */
    nearestPoint(x: number, y: number) { // returns nearest point
      return {
        x: this.x,
        y: this.y,
        distance: marietta.webcad.WebCADGlobal.snapManager.pointsDistance(this.x, this.y, x, y),
      };
    }

    /**
     * チェックポイントが最も近いポイントです
     * @param x
     * @param y
     * @param distance
     * @returns boolean
     */
    isNear(x: number, y: number, distance: number) {
      // eslint-disable-next-line no-bitwise
      return ~(this.x - x) + 1 < distance && ~(this.y - y) + 1 < distance;
    }
}
